
import React, { Component } from 'react';

import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';

import { isRequired } from '../../lib/forms/Validations';
import { InputWithErrors } from '../../lib/forms';
import { personalInfo, Auth } from '../../services'

let ChangePasswordForm = ({ translate, handleSubmit }) => {
  return (
    <div>
      <div className="card card-section" id="info">
        <div className="card-block">
          <div className="card-title">
            <h3>{translate('password')}</h3>
          </div>
          <form className="form-line edit ng-pristine ng-valid" onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-lg-10">
                <div className="row">
                  <div className="col">
                    <div className="form-group row text-md-right">
                      <label className="col-md-7 col-form-label">{translate('enter-current-password')}<span className="text-danger">*</span></label>
                      <div className="col">
                        <Field name="password" label="nom"  placeholder={translate('current-password')} translate={translate} component={InputWithErrors} className="form-control" type="password" validate={[ isRequired]} />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <div className="form-group row text-md-right">
                      <label className="col-md-7 col-form-label">{translate('enter-new-password')}<span className="text-danger">*</span></label>
                      <div className="col">
                        <Field name="newPassword" label="nom"  placeholder={translate('new-password')} translate={translate} component={InputWithErrors} className="form-control" type="password" validate={[ isRequired]} />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <div className="form-group row text-md-right" >
                      <label className="col-md-7 col-form-label">{translate('confirm-new-password')}<span className="text-danger">*</span></label>
                      <div className="col">
                        <Field name="rptNewPassword" label="nom"  placeholder={translate('password-confirmation')} translate={translate} component={InputWithErrors} className="form-control" type="password" validate={[ isRequired]} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row justify-content-end row-btn">
              <div className="col-6 col-md-3">
                <button className="btn btn-block btn-form btn-cancel" type="submit" ui-sref="personal-information" >{translate('cancel')}</button>
              </div>
              <div className="col-6 col-md-3">
                <button className="btn btn-block btn-form btn-submit" type="cancel" ui-sref="personal-information" >{translate('save')}</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}
const viewMapStateToProps = (state) => {
  return {
    translate: getTranslate(state.locale),
    currentLanguage: getActiveLanguage(state.locale).code,
  }
}

const viewMapDispatchToProps = (dispatch) => {
  return {
    setFlashMessage: (message, success) => {
      dispatch(
        {
          type: 'SET_FLASH_MESSAGE',
          message: message,
          success: success
        }
      );
    },
  };
};

ChangePasswordForm = connect(
  viewMapStateToProps,
  viewMapDispatchToProps,
)(ChangePasswordForm);

 ChangePasswordForm = reduxForm({
  form: 'ChangePassword',
  enableReinitialize: true,
})(ChangePasswordForm)

class ChangePasswordHandler extends Component {
  handleSubmit(values) {
    const { history, setFlashMessage, translate } = this.props;
    if (values.newPassword !== values.rptNewPassword) {
      setFlashMessage(`${translate('password-not-match-confirm-password')}`, false)
      return
    }
    if ((values.newPassword.length || values.rptNewPassword.length) < 6) {
      setFlashMessage(`${translate('password-length-error')}`, false)
      return
    }
    personalInfo.changePassword(values)
      .then((res) => {
        if (res.body.token) {
          Auth.setToken(res.body.token)
        }
        history.goBack();
      })
      .catch((error) => {
        if (error.status === 401) {
          Auth.logOut();
        }
        if (error.status === 422){
          setFlashMessage(error.body.errors[0].detail)
        }
      });
  }
  cancel(values) {
    const { history } = this.props;
    history.goBack();
  }
  render() {
    return (
      <div>
        <ChangePasswordForm onSubmit={this.handleSubmit.bind(this)} cancel={this.cancel.bind(this)} rest={this.props.rest}/>
      </div>
    );
  }
}
const passwodHandlerviewMapStateToProps = (state) => {
  return {
    translate: getTranslate(state.locale),
    currentLanguage: getActiveLanguage(state.locale).code,
  }
}

const passwodHandlerviewMapDispatchToProps = (dispatch) => {
  return {
    setFlashMessage: (message, success) => {
      dispatch(
        {
          type: 'SET_FLASH_MESSAGE',
          message: message,
          success: success
        }
      );
    },
  };
};

ChangePasswordHandler = connect(
  passwodHandlerviewMapStateToProps,
  passwodHandlerviewMapDispatchToProps,
)(ChangePasswordHandler);
ChangePasswordHandler = withRouter(ChangePasswordHandler);
export default ChangePasswordHandler;



// WEBPACK FOOTER //
// ./src/components/ChangePassword/ChangePassword.js